import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import {Grid} from '@material-ui/core';
import React from 'react'

const MoenyRepayments = () => {
  return (
    <div>
       <Grid item xs={12} lg={12}>
                        <TableContainer
                          component={Paper}
                          style={{ width: "100%", margin: "12px 0px" }}
                        >
                          <Table
                             aria-label="simple table"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell align="left">Date</TableCell>
                                <TableCell align="left">To Principal</TableCell>
                                <TableCell align="left">To Interest</TableCell>
                                <TableCell align="left">Amount</TableCell>
                                <TableCell align="left">Remarks</TableCell>
                                <TableCell align="left">Modified Date</TableCell>
                               
                              </TableRow>
                            </TableHead>
                            <TableBody>
                          
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Grid>
    </div>
  )
}

export default MoenyRepayments;
